// *******************
// *******************
// FILE AUTO GENERATO! n// *******************
// *******************

export const _reminderTypeUtilsData = {
  "Analisi": {
    "label": {
      "it": "Scadenza analisi",
      "de": "Ablauf der Analyse",
      "en": "Analysis deadline"
    },
    "EntityName": "Analisi"
  },
  "Bonifica": {
    "label": {
      "it": "Bonifica",
      "de": "Sanierung",
      "en": "Sanitization"
    },
    "EntityName": "Bonifica"
  },
  "Filtro": {
    "label": {
      "it": "Filtro da sostituire",
      "de": "Zu ersetzender Filter",
      "en": "Filter to replace"
    },
    "EntityName": "Filtro"
  }
} as const